import React from 'react';
import { connect } from 'react-redux';
import { decodeHtml } from 'app/utils/strings';
import StudentBrandedDocumentTitle from 'app/ui/config/StudentBrandedDocumentTitle';
import SelectUIBase from 'app/ui/config/SelectUIBase';
import withLoading from 'app/ui/core/common/withLoading';
import {
  getCurrentTitle,
  isBookNotFound,
} from 'app/api/redux-jigsaw/jigsaw-selectors';
import { BOOK_NOT_FOUND } from 'app/api/redux-route/routes';
import { isBookNoAccess } from '../../../api/redux-jigsaw/jigsaw-selectors';
import { BOOK_ACCESS_DENIED } from '../../../api/redux-route/routes';
import RedirectOnce from 'app/ui/route/RedirectOnce';
import { createUiBaseMountAction } from '../../config/createUiBaseMountAction';
import { PreloadHomePage } from '../home/HomePage';
import MountAfterTransition from '../shared/MountAfterTransition';
import SetFocusOnPageLoad from '../../jigsaw/SetFocusOnPageLoad';

const AsyncKiddieMain = withLoading(() => import('./kiddie/KiddieReaderMain'));
const AsyncMiddleMain = withLoading(() => import('./middle/MiddleReaderMain'));

export const PreloadReaderPage = createUiBaseMountAction(
  AsyncKiddieMain.preload,
  AsyncMiddleMain.preload
);

class ReaderPage extends React.Component {
  render() {
    if (this.props.notFound) {
      return <RedirectOnce to={BOOK_NOT_FOUND} />;
    } else if (this.props.noAccess) {
      return <RedirectOnce to={BOOK_ACCESS_DENIED} />;
    }

    const pageProps = {
      vbid: this.props.match.params.vbid,
    };

    return (
      <StudentBrandedDocumentTitle title={decodeHtml(this.props.title)}>
        <SetFocusOnPageLoad>
          <SelectUIBase>
            <AsyncKiddieMain {...pageProps} />
            <AsyncMiddleMain {...pageProps} />
          </SelectUIBase>
          <MountAfterTransition>
            <PreloadHomePage />
          </MountAfterTransition>
        </SetFocusOnPageLoad>
      </StudentBrandedDocumentTitle>
    );
  }
}

const mapStateToProps = state => ({
  title: getCurrentTitle(state),
  notFound: isBookNotFound(state),
  noAccess: isBookNoAccess(state),
});

export default connect(mapStateToProps)(ReaderPage);



// WEBPACK FOOTER //
// ./src/app/ui/pages/reader/ReaderPage.js